import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full h-full overflow-y-auto no-scrollbar pb-10" }
const _hoisted_2 = { class: "yeseva-one font-normal text-5xl md:text-[64px] xl:text-8xl leading-100p text-white z-10" }
const _hoisted_3 = { class: "activations-grid gap-4 md:gap-x-6 md:gap-y-[14px] xl:gap-8 justify-center px-1 sm:grow" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "font-semibold text-base leading-[21px] xl:text-2xl xl:leading-[32px] text-white z-10" }
const _hoisted_6 = { class: "flex flex-col flex-1 pb-4 md:pb-6 xl:pb-8 px-4 xl:px-8" }
const _hoisted_7 = { class: "max-md:my-4 pl-7 list-disc text-brown text-sm leading-[21px] md:text-base md:leading-[24px] xl:text-xl xl:leading-[28px] text-left flex-1 flex flex-col justify-center" }
const _hoisted_8 = {
  key: 1,
  class: "break-words"
}
const _hoisted_9 = { class: "mt-auto flex justify-center" }

import { useRouter } from "vue-router";
import { activationGroups } from "@/constants/activations";
import { ActivationGroup } from "@/types/calculators";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useI18n } from "vue-i18n";
import activationBG from "@/assets/calculators/activations/header_bg.webp";
import GradientButton from "@/components/buttons/GradientButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivationListView',
  setup(__props) {

const router = useRouter();

const { t } = useI18n();

function openActivation(group: ActivationGroup) {
  router.push({
    name: ROUTE_NAMES.ACTIVATION_FORM,
    query: {
      activation: group.key,
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "relative w-full h-[204px] md:h-[259px] xl:h-[342px] overflow-hidden bg-cover bg-center flex items-end pl-4 pb-[23px] md:pl-6 md:pb-[69px] xl:pl-[73px] xl:pb-[83px] mb-4 md:mb-6 xl:mb-10",
      style: _normalizeStyle({
        backgroundImage: `url(${_unref(activationBG)})`,
      })
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute inset-0 bg-mono-brown-gradient" }, null, -1)),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)("calculators.activations.title")), 1)
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activationGroups), (group) => {
        return (_openBlock(), _createElementBlock("div", {
          key: group.key,
          class: "flex flex-col bg-white rounded-2xl w-full max-md:min-h-[336px] md:h-[432px] xl:h-[530px] cursor-pointer group/gradient card-shadow",
          onClick: ($event: any) => (openActivation(group))
        }, [
          _createElementVNode("div", {
            class: "relative w-full h-32 md:h-32 xl:h-[206px] overflow-hidden bg-cover bg-center flex items-end pb-2 md:pb-4 xl:pb-6 justify-center rounded-t-2xl",
            style: _normalizeStyle({
            backgroundImage: `url(${require(`@/assets/calculators/activations/${group.key}.jpg`)})`,
          })
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute inset-0 bg-mono-brown-gradient group-hover/gradient:bg-mono-active-gradient" }, null, -1)),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)(`calculators.activations.group.${group.key}`)), 1)
          ], 4),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("ul", _hoisted_7, [
              (group.activationKeys && group.activationKeys.length > 1)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(group.activationKeys, (key) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: key,
                      class: "break-words"
                    }, _toDisplayString(_unref(t)(`calculators.activations.activation_list.${key}`)), 1))
                  }), 128))
                : (_openBlock(), _createElementBlock("li", _hoisted_8, _toDisplayString(_unref(t)(`calculators.activations.group_descriptions.${group.key}`)), 1))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(GradientButton, {
                class: "w-[153px] h-[46px] md:w-[191px] md:h-14",
                "bg-color": "bg-brown-gradient",
                "hover-bg-color": "bg-orange-gradient",
                text: "Рассчитать"
              })
            ])
          ])
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})